<template>
  <v-container fluid>
    <PageTitle>
      Search for Email Addresses
    </PageTitle>

    <v-form @submit.prevent="submit"
            :disabled="form.busy">
      <v-card class="mb-4">
        <v-card-text>
          <v-text-field v-model="form.email"
                        type="email"
                        label="Email address"
                        outlined
                        dense
                        :disabled="form.busy"
                        :error-messages="form.errors.get('email')">
          </v-text-field>
        </v-card-text>
        <v-card-actions class="px-4">
          <v-btn type="submit"
                 color="primary">
            Search
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>

    <v-card v-if="emailAddress"
            class="mb-4">
      <v-simple-table>
        <thead>
        <tr>
          <th>
            ID
          </th>
          <th>
            Email
          </th>
          <th>
            Overridden
          </th>
          <th>
            Delivery Status
          </th>
          <th>
            Mailgun
          </th>
          <th>
            NeverBounce
          </th>
          <th>
            Enrichley
          </th>
          <th>
            MailboxLayer
          </th>
          <th>
            CaptainVerify
          </th>
          <th>
            Actions
          </th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td>
            {{ emailAddress.id }}
          </td>
          <td>
            {{ emailAddress.email }}
          </td>
          <td>
            <template v-if="emailAddress.is_overridden">
              {{ emailAddress.overridden_at | datetime('YYYY-MM-DD HH:mm:ss') }}
            </template>
            <template v-else>
              No
            </template>
          </td>
          <td>
            {{ emailAddress.delivery_status }}
            <div v-if="emailAddress.delivery_status_at"
                 class="text-caption">
              {{ emailAddress.delivery_status_at | datetime('YYYY-MM-DD') }}
            </div>
          </td>
          <td>
            {{ emailAddress.mg_result }}
            <div v-if="emailAddress.mg_result_date"
                 class="text-caption">
              {{ emailAddress.mg_result_date }}
            </div>
          </td>
          <td>
            {{ emailAddress.nb_result }}
            <div v-if="emailAddress.nb_result_date"
                 class="text-caption">
              {{ emailAddress.nb_result_date }}
            </div>
          </td>
          <td>
            {{ emailAddress.en_result }}
            <div v-if="emailAddress.en_result_date"
                 class="text-caption">
              {{ emailAddress.en_result_date }}
            </div>
          </td>
          <td>
            {{ emailAddress.mb_result }}
            <div v-if="emailAddress.mb_result_date"
                 class="text-caption">
              {{ emailAddress.mb_result_date }}
            </div>
          </td>
          <td>
            {{ emailAddress.cv_result }}
            <div v-if="emailAddress.cv_result_date"
                 class="text-caption">
              {{ emailAddress.cv_result_date }}
            </div>
          </td>
          <td>
            <v-menu bottom
                    offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn x-small
                       :disabled="form.busy"
                       v-on="on"
                       v-bind="attrs">
                  Actions
                  <v-icon right>
                    fal fa-fw fa-chevron-down
                  </v-icon>
                </v-btn>
              </template>
              <v-list dense>
                <v-list-item @click.prevent="verify">
                  <v-list-item-content>
                    <v-list-item-title>
                      Verify
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item @click.prevent="override">
                  <v-list-item-content>
                    <v-list-item-title>
                      Override
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
          </td>
        </tr>
        </tbody>
      </v-simple-table>
    </v-card>
  </v-container>
</template>
<script>
import {Form} from 'vform';
import PageTitle from '../../components/PageTitle.vue';
import emailVerificationService from '../../services/emailVerificationService';
import emailAddressService from '../../services/emailAddressService';

export default {
  components: {PageTitle},
  data() {
    return {
      form: new Form({
        email: '',
      }),
      emailAddress: null,
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {

    },
    submit() {
      if (this.form.busy) {
        return;
      }
      return emailAddressService.search(this.form)
        .then(data => {
          this.emailAddress = data;
        })
        .catch(err => {

        })
    },
    verify() {
      if (this.form.busy) {
        return;
      }
      return emailVerificationService.verify(this.form)
        .then(data => {
          this.submit();
        })
        .catch(err => {

        })
    },
    override() {
      if (this.form.busy) {
        return;
      }
      return emailVerificationService.override(this.form)
        .then(data => {
          this.submit();
        })
        .catch(err => {

        })
    }
  }
}
</script>
